import React from "react";

// Components
import Link from "../Atoms/Link";

// Stylesheets
import "./SocialIcons.scss";

// Constants
import { SOCIAL_MEDIA_LINKS } from "../../utils/constants";
import VisuallyHidden from "@reach/visually-hidden";

export const SocialIcons = () => {
  // GTM Track - Social Share
  const trackSocialShare = (event) => {
    window.dataLayer.push({
      event: "interactionEvent",
      event_name: "social_share",
      events: {
        social: String(event).toLowerCase(),
      },
    });
  };

  return (
    <div className="social_links">
      {SOCIAL_MEDIA_LINKS.map(({ title, linkProps, logo }, idx) => (
        <Link
          key={idx}
          title={title}
          {...linkProps}
          onClick={() => trackSocialShare(title)}
        >
          {logo}
          <VisuallyHidden>{`Visit our ${title}`}</VisuallyHidden>
        </Link>
      ))}
    </div>
  );
};

export default SocialIcons;
